import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const STATS = [
  { value: 120, suffix: "+", label: "Global Ports Served" },
  { value: 6, suffix: " Million+", label: "Cargo Value Delivered" },
  { value: 99.8, suffix: "%", label: "On-Time Clearance" },
  { value: 42, suffix: "", label: "Country Network" },
];

function Counter({ value, prefix = "", suffix = "" }) {
  const [n, setN] = useState(0);
  const ref = useRef();
  const started = useRef(false);
  useEffect(() => {
    const el = ref.current;
    const obs = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !started.current) {
        started.current = true;
        const dur = 1600;
        const t0 = performance.now();
        const tick = (t) => {
          const p = Math.min((t - t0) / dur, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          setN(value * eased);
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
    }, { threshold: 0.4 });
    if (el) obs.observe(el);
    return () => obs.disconnect();
  }, [value]);
  const display = value % 1 === 0 ? Math.round(n) : n.toFixed(1);
  return <span ref={ref}>{prefix}{display}{suffix}</span>;
}

export default function Stats() {
  return (
    <section id="network" className="relative overflow-hidden border-y border-white/10 bg-[#0E1626] py-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-12 flex items-center gap-3">
          <span className="h-px w-10 bg-[#D4AF37]" />
          <span className="data-label">05 — By The Numbers</span>
        </div>
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              data-testid={`stat-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
            >
              <p className="text-3xl font-bold leading-none tracking-tight text-white sm:text-4xl lg:text-5xl">
                <Counter value={s.value} prefix={s.prefix} suffix={s.suffix} />
              </p>
              <p className="mt-2 text-sm text-slate-400">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
